export const exercisesList = {
  nonVR: [
    { name: "Vergence-I", code: "vergence1", type: "Binocular" },
    { name: "Perceive", code: "perceivemono", type: "Monocular" },
    { name: "Perceive", code: "perceivebino", type: "Binocular" },
    { name: "Recourse-II", code: "recoursemono2", type: "Monocular" },
    { name: "Recourse-II", code: "recoursebino2", type: "Binocular" },
    { name: "Glide-I", code: "glide1", type: "Binocular" },
    { name: "Glide-II", code: "glide2", type: "Binocular" },
    { name: "Glide-III", code: "glide3", type: "Monocular" },
    { name: "Glide-IV", code: "glide4", type: "Monocular" },
    { name: "Drub", code: "drubmono", type: "Monocular" },
    { name: "Drub", code: "drubbino", type: "Binocular" },
    { name: "Illustration-I", code: "illustration1", type: "Binocular" },
    { name: "Fleeting-I", code: "fleeting1", type: "Binocular" },
    { name: "Glance", code: "glancemono", type: "Monocular" },
    { name: "Glance", code: "glancebino", type: "Binocular" },
    { name: "Opt-I", code: "optmono1", type: "Monocular" },
    { name: "Opt-I", code: "optbino1", type: "Binocular" },
    { name: "Recourse-I (mono)", code: "recoursemono1", type: "Monocular" },
    { name: "Recourse-I (bino)", code: "recoursebino1", type: "Binocular" },
    { name: "Discover", code: "discover", type: "Monocular" },
    { name: "Direction-I", code: "direction1", type: "Binocular" },
    { name: "Direction-II", code: "direction2", type: "Binocular" },
    { name: "Direction-III", code: "direction3", type: "Binocular" },
    { name: "G-Discern-I", code: "gdiscerngabor1", type: "NeuroVision" },
    { name: "G-Discern-II", code: "gdiscerngabor2", type: "NeuroVision" },
    { name: "G-Flash-I", code: "gflashgabor1", type: "NeuroVision" },
    { name: "G-Flash-II", code: "gflashgabor2", type: "NeuroVision" },
    { name: "G-Identify", code: "gidentifygabor", type: "NeuroVision" },
    { name: "G-Locate", code: "glocategabor", type: "NeuroVision" },
    { name: "G-Pick-I", code: "gpickgabor1", type: "NeuroVision" },
    { name: "G-Pick-II", code: "gpickgabor2", type: "NeuroVision" },
    { name: "G-PinPoint", code: "gpinpointgabor", type: "NeuroVision" },
    { name: "W-Discern-I", code: "wdiscerngabor1", type: "NeuroVision" },
    { name: "W-Discern-II", code: "wdiscerngabor2", type: "NeuroVision" },
    { name: "W-Flash-I", code: "wflashgabor1", type: "NeuroVision" },
    { name: "W-Flash-II", code: "wflashgabor2", type: "NeuroVision" },
    { name: "W-Identify", code: "widentifygabor", type: "NeuroVision" },
    { name: "W-Locate", code: "wlocategabor", type: "NeuroVision" },
    { name: "W-Pick-I", code: "wpickgabor1", type: "NeuroVision" },
    { name: "W-Pick-II", code: "wpickgabor2", type: "NeuroVision" },
    { name: "W-PinPoint", code: "wpinpointgabor", type: "NeuroVision" },
    { name: "Ring Base-Out", code: "ringbaseout", type: "BaseInBaseOut" },
    { name: "Ring Base-In", code: "ringbasein", type: "BaseInBaseOut" },
    { name: "Ring Base-In-Out", code: "ringbaseinout", type: "BaseInBaseOut" },
    { name: "Square Base-Out", code: "squarebaseout", type: "BaseInBaseOut" },
    { name: "Square Base-In", code: "squarebasein", type: "BaseInBaseOut" },
    { name: "Square Base-In-Out", code: "squarebaseinout", type: "BaseInBaseOut" },
    { name: "Circle Base-Out", code: "circlebaseout", type: "BaseInBaseOut" },
    { name: "Circle Base-In", code: "circlebasein", type: "BaseInBaseOut" },
    { name: "Circle Base-In-Out", code: "circlebaseinout", type: "BaseInBaseOut" },
    { name: "Race Runner I", code: "racerunnerredbino", type: "Binocular" },
    { name: "Race Runner II", code: "racerunnerbluebino", type: "Binocular" },
    { name: "Race Runner Mono", code: "racerunnermono", type: "Monocular" },
    { name: "Fuitninja I", code: "fruitninjaredbino", type: "Binocular" },
    { name: "Fuitninja II", code: "fruitninjabluebino", type: "Binocular" },
    { name: "Fuitninja Mono", code: "fruitninjamono", type: "Monocular" },
    { name: "Buzz Wire I", code: "buzzwireredbino", type: "Binocular" },
    { name: "Buzz Wire II", code: "buzzwirebluebino", type: "Binocular" },
    { name: "Buzz Wire Mono", code: "buzzwiremono", type: "Monocular" },
    { name: "Groceries Catch I", code: "groceriescatchredbino", type: "Binocular" },
    { name: "Groceries Catch II", code: "groceriescatchbluebino", type: "Binocular" },
    // { name: "Groceries Catch Mono", code: "groceriescatchmono", type: "Monocular" },
    { name: "Drop Catch I", code: "dropcatchredbino", type: "Binocular" },
    { name: "Drop Catch II", code: "dropcatchbluebino", type: "Binocular" },
    // { name: "Drop Catch Mono", code: "dropcatchmono", type: "Monocular" },
    { name: "Duck Shooter I", code: "duckshooterredbino", type: "Binocular" },
    { name: "Duck Shooter II", code: "duckshooterbluebino", type: "Binocular" },
    // { name: "Duck Shooter Mono", code: "duckhuntmono", type: "Monocular" },
    { name: "Balloon Shooter I", code: "balloonshooterredbino", type: "Binocular" },
    { name: "Balloon Shooter II", code: "balloonshooterbluebino", type: "Binocular" },
    { name: "Balloon Shooter Mono", code: "balloonshootermono", type: "Monocular" },
    { name: "Rocket Sprint I", code: "rocketsprintredbino", type: "Binocular" },
    { name: "Rocket Sprint II", code: "rocketsprintbluebino", type: "Binocular" },
    { name: "Rocket Sprint Mono", code: "rocketsprintmono", type: "Monocular" },
    { name: "Shadow Catch I", code: "shadowcatchredbino", type: "Binocular" },
    { name: "Shadow Catch II", code: "shadowcatchbluebino", type: "Binocular" },
    { name: "Shadow Catch Mono", code: "shadowcatchmono", type: "Monocular" },

    { name: "G-Cannon", code: "gcannongabor", type: "NeuroVision"},
    { name: "W-Cannon", code: "wcannongabor", type: "NeuroVision"},
    { name: "G-Crush", code: "gcrushgabor", type: "NeuroVision"},
    { name: "W-Crush", code: "wcrushgabor", type: "NeuroVision"},
    { name: "G-Ninja", code: "gninjagabor", type: "NeuroVision"},
    { name: "W-Ninja", code: "wninjagabor", type: "NeuroVision"},
    { name: "G-Toss", code: "gtossgabor", type: "NeuroVision"},
    { name: "W-Toss", code: "wtossgabor", type: "NeuroVision"},
    { name: "G-Shot", code: "gshotgabor", type: "NeuroVision"},
    { name: "W-Shot", code: "wshotgabor", type: "NeuroVision"}
  ],
  vr: [
    { name: "Apple Catcher Both(A)", code: "applecatcher_blur", type: "AntiSuppression" },
    { name: "Apple Catcher Left(A)", code: "applecatcher_blur_0", type: "AntiSuppression" },
    { name: "Apple Catcher Right(A)", code: "applecatcher_blur_1", type: "AntiSuppression" },
    { name: "Apple Catcher Both(D)", code: "applecatcher_black", type: "Dichoptic" },
    { name: "Apple Catcher Left(D)", code: "applecatcher_black_0", type: "Dichoptic" },
    { name: "Apple Catcher Right(D)", code: "applecatcher_black_1", type: "Dichoptic" },

    { name: "Balloon Popper Both(A)", code: "balloonpopper_blur", type: "AntiSuppression" },
    { name: "Balloon Popper Left(A)", code: "balloonpopper_blur_0", type: "AntiSuppression" },
    { name: "Balloon Popper Right(A)", code: "balloonpopper_blur_1", type: "AntiSuppression" },
    { name: "Balloon Popper Both(D)", code: "balloonpopper_black", type: "Dichoptic" },
    { name: "Balloon Popper Left(D)", code: "balloonpopper_black_0", type: "Dichoptic" },
    { name: "Balloon Popper Right(D)", code: "balloonpopper_black_1", type: "Dichoptic" },

    { name: "Mole Whacker Both(A)", code: "molewhacker_blur", type: "AntiSuppression" },
    { name: "Mole Whacker Left(A)", code: "molewhacker_blur_0", type: "AntiSuppression" },
    { name: "Mole Whacker Right(A)", code: "molewhacker_blur_1", type: "AntiSuppression" },
    { name: "Mole Whacker Both(D)", code: "molewhacker_black", type: "Dichoptic" },
    { name: "Mole Whacker Left(D)", code: "molewhacker_black_0", type: "Dichoptic" },
    { name: "Mole Whacker Right(D)", code: "molewhacker_black_1", type: "Dichoptic" },

    { name: "Bubble Popper Both(A)", code: "bubblepopper_blur", type: "AntiSuppression" },
    { name: "Bubble Popper Left(A)", code: "bubblepopper_blur_0", type: "AntiSuppression" },
    { name: "Bubble Popper Right(A)", code: "bubblepopper_blur_1", type: "AntiSuppression" },
    { name: "Bubble Popper Both(D)", code: "bubblepopper_black", type: "Dichoptic" },
    { name: "Bubble Popper Left(D)", code: "bubblepopper_black_0", type: "Dichoptic" },
    { name: "Bubble Popper Right(D)", code: "bubblepopper_black_1", type: "Dichoptic" },

    { name: "Fruit Slasher Both(A)", code: "fruitslasher_blur", type: "AntiSuppression" },
    { name: "Fruit Slasher Left(A)", code: "fruitslasher_blur_0", type: "AntiSuppression" },
    { name: "Fruit Slasher Right(A)", code: "fruitslasher_blur_1", type: "AntiSuppression" },
    { name: "Fruit Slasher Both(D)", code: "fruitslasher_black", type: "Dichoptic" },
    { name: "Fruit Slasher Left(D)", code: "fruitslasher_black_0", type: "Dichoptic" },
    { name: "Fruit Slasher Right(D)", code: "fruitslasher_black_1", type: "Dichoptic" },

    { name: "Duck Hunter Both(A)", code: "duckhunter_blur", type: "AntiSuppression" },
    { name: "Duck Hunter Left(A)", code: "duckhunter_blur_0", type: "AntiSuppression" },
    { name: "Duck Hunter Right(A)", code: "duckhunter_blur_1", type: "AntiSuppression" },
    { name: "Duck Hunter Both(D)", code: "duckhunter_black", type: "Dichoptic" },
    { name: "Duck Hunter Left(D)", code: "duckhunter_black_0", type: "Dichoptic" },
    { name: "Duck Hunter Right(D)", code: "duckhunter_black_1", type: "Dichoptic" },

    { name: "Brock String(d)", code: "brockstring", type: "DepthPerception" },
    { name: "Bubble Pop(d)", code: "bubblepopdp", type: "DepthPerception" },
    { name: "Cube Punch(d)", code: "cubepunch", type: "DepthPerception" },
    { name: "Hoopin(d)", code: "hoopin", type: "DepthPerception" }
  ],
}

export const SCORE_REPORT_TABS = {
  nonVR: [
    { key: "all", label: "ALL" },
    { key: "Binocular", label: "BINOCULAR" },
    { key: "Monocular", label: "MONOCULAR" },
    { key: "NeuroVision", label: "NEUROVISION" },
    // { key: "Baseinbaseout", label: "BASE-IN BASE-OUT" },
  ],
  vr: [
    { key: "all", label: "ALL" },
    { key: "AntiSuppression", label: "ANTISUPPRESSION(A)" },
    { key: "Dichoptic", label: "DICHOPTIC(D)" },
    { key: "DepthPerception", label: "DEPTHPERCEPTION(d)" }
  ],
}
